import { ref } from 'vue';

export const useHandoverStore = () => {
  // 검색 키워드
  const searchKeyword = ref('');
  const recipientSearchKeyword = ref('');

  // 선택된 담당자
  const selectedFromUser = ref(null);
  const selectedToUser = ref(null);

  // 필터 선택 값
  const selectedBoard = ref(null);
  const selectedCategory = ref(null);
  const selectedTaskStatus = ref(null);
  const selectedResultStatus = ref(null);
  const selectedProgressStatus = ref(null);

  // 필터 옵션 (담당자 선택 전·초기화 시 빈 목록 — placeholder만 표시)
  const boardOptions = ref([]);

  const categoryOptions = ref([]);

  const taskStatusOptions = ref([]);

  const resultStatusOptions = ref([]);

  const progressStatusOptions = ref([]);

  // 업무 목록 (더미 데이터)
  const taskList = ref([]);

  // 선택된 업무 ID 목록
  const selectedTasks = ref([]);

  // 담당자 선택 모달 관련
  const showUserSelectModal = ref(false);
  const userNameFilter = ref('');
  const userPositionFilter = ref(null);
  const userRankFilter = ref(null);

  // 직위 옵션
  const positionOptions = [
    { label: '전체', value: '' },
    { value: 'manager', label: '팀장' },
    { value: 'leader', label: '리더' },
    { value: 'member', label: '팀원' }
  ];

  // 직급 옵션
  const rankOptions = [
    { label: '전체', value: '' },
    { value: 'senior', label: '수석' },
    { value: 'principal', label: '책임' },
    { value: 'senior_manager', label: '차장' },
    { value: 'manager', label: '과장' },
    { value: 'assistant_manager', label: '대리' },
    { value: 'staff', label: '사원' }
  ];

  // 담당자 선택 모달 변수
  const modalMode = ref<null>;

  // 업무 전달 모달 메시지
  const handoverConfirmMessage = ref('');

  return {
    searchKeyword,
    recipientSearchKeyword,
    selectedFromUser,
    selectedToUser,
    selectedBoard,
    selectedCategory,
    selectedTaskStatus,
    selectedResultStatus,
    selectedProgressStatus,
    boardOptions,
    categoryOptions,
    taskStatusOptions,
    resultStatusOptions,
    progressStatusOptions,
    taskList,
    selectedTasks,
    showUserSelectModal,
    userNameFilter,
    userPositionFilter,
    userRankFilter,
    positionOptions,
    rankOptions,
    modalMode,
    handoverConfirmMessage
  };
};
